import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import Vuelidate from 'vuelidate'

const Vue = createApp(App)
Vue.use(Quasar, quasarUserOptions)
Vue.use(Vuelidate)
Vue.use(store)
Vue.use(router)
Vue.mount('#app')
